import React, { useState, createContext, useContext } from 'react';
// Define the price structure
export interface Prices {
  gen3Body: number;
  gen3Head: number;
  gen3JudgesOnly: number;
  fullGen3Ring: number;
  technician: number;
  taxRate: number;
}
// Default prices
const defaultPrices: Prices = {
  gen3Body: 700,
  gen3Head: 425,
  gen3JudgesOnly: 350,
  fullGen3Ring: 900,
  technician: 500,
  taxRate: 0.09
};
interface PriceContextType {
  prices: Prices;
  updatePrices: (newPrices: Partial<Prices>) => void;
  resetPrices: () => void;
}
const PriceContext = createContext<PriceContextType | undefined>(undefined);
export const PriceProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  // Use default prices without localStorage
  const [prices, setPrices] = useState<Prices>(defaultPrices);
  const updatePrices = (newPrices: Partial<Prices>) => {
    setPrices(prevPrices => ({
      ...prevPrices,
      ...newPrices
    }));
  };
  const resetPrices = () => {
    setPrices(defaultPrices);
  };
  return <PriceContext.Provider value={{
    prices,
    updatePrices,
    resetPrices
  }} data-id="element-2200">
      {children}
    </PriceContext.Provider>;
};
// Custom hook to use the price context
export const usePrices = () => {
  const context = useContext(PriceContext);
  if (context === undefined) {
    throw new Error('usePrices must be used within a PriceProvider');
  }
  return context;
};